import { render, staticRenderFns } from "./journalAccount.vue?vue&type=template&id=5c64adbd"
import script from "./journalAccount.vue?vue&type=script&lang=js"
export * from "./journalAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports